/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../../components/Link";
import { VerifyScan } from "../../components/VerifyScan";
import "./styles.less";
export const DatabasePageContentBlock = ({
  imgUrl,
  content,
  position = "back",
  aside = null,
  layout,
}) => {
  return (
    <div className={`verifyPage-content ${position} ${layout}`}>
      <div className="text-box">{content}</div>
      {aside || (
        <div className="img-box">
          <img src={imgUrl} />
        </div>
      )}
    </div>
  );
};

export const DatabasePageContent = () => {
  const { t } = useTranslation();

  const cardTwoContent = {
    imgUrl: "//files.authing.co/authing-website/database-page-solution-new.png",
    position: "front",
    content: (
      <div>
        <h3 className="headline">{t("learn.databasePage.solutions.title")}</h3>
        <div className="paragraph">
          {t("learn.databasePage.solutions.descript")}
        </div>
      </div>
    ),
  };
  const cardThreeContent = {
    imgUrl: "//files.authing.co/authing-website/database-page-sence-new.png",
    position: "back",
    content: (
      <div>
        <h3 className="headline">{t("learn.databasePage.sence.title")}</h3>
        <div className="paragraph">
          {t("learn.databasePage.sence.descript")}
        </div>
        <div className="paragraph">
          <div className="text">{t("learn.databasePage.sence.list1")}</div>
        </div>
        <div className="paragraph">
          <div className="text">{t("learn.databasePage.sence.list2")}</div>
        </div>
        <div className="paragraph">
          <div className="text">{t("learn.databasePage.sence.list3")}</div>
        </div>
      </div>
    ),
  };
  return (
    <div className="database-content-solution">
      <DatabasePageContentBlock {...cardTwoContent} />
      <DatabasePageContentBlock {...cardThreeContent} />
    </div>
  );
};
